<!-- 头部组件 -->
<template>
    <div class="top">
        <div class="logo-left">
                   
        </div> 
        <Menu></Menu>
        <div class="login">
            <!-- <img src="../assets/images/avatar.png" alt="" class="avatar"> -->
            <template v-if="isLogin == 0" >
                <span class="login-txt mg-r-20" >{{realName}} </span>
                <span class="login-txt mg-r-20" >{{userId}} </span>
                <!-- <span class="login-txt" @click="handlePassword"> 修改密码 </span>  -->
                <span class="login-txt" @click="logout"> 退出 </span>
            </template>            
            <template v-else>
                <span class="login-txt mg-r-50" @click="handleLogin">登录</span>
                <span class="login-txt" @click="handleRegister"> 注册 </span>
            </template>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="20%"
            >
            <span>您确定退出吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="comfirmLogout">确 定</el-button>
            </span>
            </el-dialog> 
    </div>   
</template>

<script>
import { mapState } from 'vuex';
import Menu from './Menu'
export default {
    components:{
        Menu
    },
    data() {
        return {
            dialogVisible:false,
            dialogShow:false,
        }
    },
    computed:{
        isLogin(v){            
            let login = localStorage.getItem('isLogin');
            return login;
        },
        realName(){
           return localStorage.getItem('realName')
        },
        port(){
            return window.location.port
        },
        userId(){
            return localStorage.userId
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        download(){
            this.$router.push('/download')
        },
        handleLogin(){
            this.$router.replace('/login')
        },
        handleRegister(){
            this.$router.push('/register')
        },
        dialogClose(v) {
            this.dialogVisible = v;    
        },
        home(){
            this.$router.push('/')
        },
        logout(){
            this.dialogVisible = true          
        },
        handlePassword(){
            this.$router.push('/modifyPassword')
        },
        comfirmLogout(){
            // localStorage.setItem("realName","")
            // localStorage.setItem("isLogin",false)   
            // localStorage.setItem("token",'')   
            // localStorage.setItem('roles', '')
            for (let key in localStorage) {
                if (localStorage.hasOwnProperty(key)) {
                    localStorage.removeItem(key);
                }
            }
            this.dialogVisible = false
            setTimeout(()=>{
                this.$router.push({
                        path: '/login',
                    })
            },50)   
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.qrcode{
    position:absolute;
    top:50px;
    display:none;
    z-index:22;
    background-color:#fff;
    text-align:center;
    color:#333
}
.qrcode-txt{
    padding-bottom:5px
}
.weixin:hover .qrcode{
    display:block
}

</style>


// WEBPACK FOOTER //
// src/components/Header.vue